import { TYPES_PARAMS_STRAPI } from '../Common';

const paramsBlogPost = (idTitle) => {
  return `blog-posts?filters[$or][0][title][$eq]=${idTitle}&filters[$or][1][title][$eq]=${idTitle}?&fields=${TYPES_PARAMS_STRAPI.filedsPost}&populate=${TYPES_PARAMS_STRAPI.populates.categorieImageAndSeo}`;
};

export {
  paramsBlogPost,
};
